import { useHasAccess } from 'lib-shared-access-control';

import { ConversationAuditLogEntry } from 'apis/auditLogs';
import { AppLink } from 'components/appLink';

import { LogEntry } from './logEntry';

type ConversationSlaEvaluationProps = {
  entry: ConversationAuditLogEntry<'CONVERSATION_SLA_EVALUATION'>;
};

export const ConversationSlaEvaluation = ({
  entry,
}: ConversationSlaEvaluationProps): JSX.Element => {
  const hasSLAAccess = useHasAccess('settings.sla');

  const metricLabel = entry.sla_metric_type.replace(/_/g, ' ').toLowerCase();

  const policyName = hasSLAAccess ? (
    <AppLink
      path="/settings/sla/policies/:id"
      params={{ path: { id: `${entry.sla_policy_id}` } }}
    >
      {entry.sla_policy_name}
    </AppLink>
  ) : (
    entry.sla_policy_name
  );

  const text = (() => {
    switch (entry.status.toLowerCase()) {
      case 'pending':
        return (
          <>
            SLA {metricLabel} evaluation started for policy {policyName}
          </>
        );
      case 'complied':
        return (
          <>
            SLA {metricLabel} target achieved for policy {policyName}
          </>
        );
      case 'breached':
        return (
          <>
            SLA {metricLabel} target breached for policy {policyName}
          </>
        );
      case 'voided':
        return (
          <>
            SLA {metricLabel} evaluation voided for policy {policyName}
          </>
        );
      default:
        return (
          <>
            SLA {metricLabel} evaluation updated for policy {policyName}
          </>
        );
    }
  })();

  return <LogEntry entry={entry} text={text} icon="hourglass-clock" />;
};
